import { BG_STYLES, BORDER_STYLES, BottomDrawer, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from "@dehaat/dds";
import React from "react";
import { Pressable, Text, View } from "react-native";

type RoleSelectionProps = {
  visible: boolean;
  roles: string[];
  onSelect: (role: string) => void;
};

const RoleSelection = ({
  visible,
  roles,
  onSelect,
}: RoleSelectionProps) => {
  return (
    <BottomDrawer
      visible={visible}
      heading="Select Your Role"
    >
      <Text style={[
        TYPOGRAPHY.TEXT2,
        VARIANTS_STYLES.BASE,
        TEXT_STYLES.textNeutral90,
        COMMON_STYLES.pb1
      ]}>
        Multiple roles found for your account. Please select one to continue:
      </Text>

      <View style={{ gap: 12 }}>
        {roles.map((role, index) => (
          <Pressable
            key={index}
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.p1,
              BG_STYLES.bgNeutral10,
              COMMON_STYLES.br1,
              BORDER_STYLES.borderNeutral20,
              COMMON_STYLES.b1,
            ]}
            onPress={() => onSelect(role)}
          >
            <Text style={[
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral90
            ]}>
              {role}
            </Text>
          </Pressable>
        ))}
      </View>
    </BottomDrawer>
  )
};

export default RoleSelection;